import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AsignacionStockComponent } from './asignacion-stock.component';
import { MaterialModule } from '../../../components/material/material.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PipesModule } from '../../../pipes/pipes.module';
import { BotonActionModule } from '../../../components/boton-action/boton-action.module';
import { ArchivoModule } from '../../../components/archivo/archivo.module';
import { MostrarItemModule } from '../../cotizaciones/items/mostrar-item/mostrar-item.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { ComunicacionService } from '../../../providers/comunicacion.service';
import { OtService } from '../../../providers/ot.service';
import { BuscarOtComponent } from './buscar-ot/buscar-ot.component';
import { MostrarOtModule } from '../../ot/mostrar-ot/mostrar-ot.module';
import { ImprimirAsignacionComponent } from './imprimir-asignacion/imprimir-asignacion.component';

@NgModule({
  declarations: [
    AsignacionStockComponent,
    BuscarOtComponent,
    ImprimirAsignacionComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    PipesModule,
    BotonActionModule,
    ArchivoModule,
    MostrarItemModule,
    NgSelectModule,
    MostrarOtModule,
  ],
  entryComponents: [
    AsignacionStockComponent,
    BuscarOtComponent,
    ImprimirAsignacionComponent,
  ],
  exports: [
  ],
  providers: [
    ComunicacionService,
    OtService,
  ]
})
export class AsignacionStockModule { }
